import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import styles from "./CustomTooltip.module.scss";

interface CustomTooltipProps extends TooltipProps {
  useDarkTheme?: boolean;
}

const CustomTooltip = ({ useDarkTheme = false, ...props }: CustomTooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{
      tooltip: useDarkTheme ? styles.customTooltipDark : styles.customTooltip,
      arrow: useDarkTheme ? "" : styles.arrow 
    }}
  />
);

export default CustomTooltip;

